var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenLinkRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4 18C34.4 27.0575 27.0575 34.4 18 34.4C8.94253 34.4 1.6 27.0575 1.6 18C1.6 8.94253 8.94253 1.6 18 1.6C27.0575 1.6 34.4 8.94253 34.4 18ZM36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18ZM10.4854 23.1609C10.4854 24.4599 11.5418 25.5147 12.8391 25.5147H23.1609C24.4599 25.5147 25.5146 24.4599 25.5164 23.1609V18.2549H24.4617V23.1627C24.4617 23.8799 23.8781 24.4617 23.1627 24.4617H12.8391C12.1219 24.4617 11.54 23.8781 11.54 23.1627V12.8215C11.54 12.1148 12.1148 11.54 12.8215 11.54H17.7451V10.4854H12.8215C11.533 10.4854 10.4854 11.533 10.4854 12.8215V23.1609ZM25.5059 14.8887H24.4512V12.2931L18.388 18.3562L17.6424 17.6106L23.7041 11.5488H21.1113V10.4941H25.5059V14.8887Z",
    fill: "#517DDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLinkRound);
export default __webpack_public_path__ + "static/media/Open_link_round.3c5fe9cbbecf24605ada1057a42c2a54.svg";
export { ForwardRef as ReactComponent };